import { axios } from '@/api/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  RoleCreateModel,
  RoleUpdateModel,
  RoleUpdateSchema,
} from './mutation.schema'

export async function createRole(data: RoleCreateModel): Promise<void> {
  await axios.post('/api/masterdata/roles', data)
}

export const useCreateRoleMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['roles'] })
    },
  })
}

export async function updateRole(data: RoleUpdateModel): Promise<void> {
  const patch = RoleUpdateSchema.parse(data)
  await axios.put(`/api/masterdata/roles/${data.id}`, patch)
}

export const useUpdateRoleMutation = (id: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['roles', 'update', id],
    mutationFn: updateRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['roles'] })
    },
  })
}

// =================  delete party =================

export const useDeleteRoleMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => axios.delete(`/api/masterdata/roles/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['roles'] })
    },
  })
}
